import { XCircle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router';

import { Button } from '../../components/ui/button';

const PaymentFailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const message = searchParams.get('message') ?? '결제가 취소되었거나 실패했습니다.';
  const code = searchParams.get('code');

  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border bg-white p-8 text-center shadow-sm">
        <div className="flex flex-col items-center gap-4">
          <XCircle className="h-14 w-14 text-red-500" />
          <h1 className="text-xl font-bold">결제에 실패했습니다</h1>
          <p className="text-sm text-muted-foreground">{message}</p>
          {code && <p className="text-xs text-muted-foreground">오류 코드: {code}</p>}
          <Button className="mt-2 w-full" onClick={() => navigate('/course')}>
            강좌 목록으로 돌아가기
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailPage;
